@if (state$ | async; as state) {
  @if (state.open) {
    <div
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 p-4"
      (click)="close()"
    >
      <div
        class="w-full max-w-[360px] overflow-hidden rounded-2xl bg-[var(--color-white)] dark:bg-[var(--color-dark-bg-secondary)] shadow-2xl border border-black/5 dark:border-[var(--color-white)]/10"
        (click)="$event.stopPropagation()"
      >
        <div class="h-2" [ngClass]="getAccentClasses(state.intent)"></div>
        <div class="px-6 pb-6 pt-6 text-center">
          <div
            class="mx-auto flex h-16 w-16 items-center justify-center rounded-full ring-8"
            [ngClass]="getIconWrapperClasses(state.intent)"
          >
            <fa-icon [icon]="getIcon(state.icon)" class="text-xl"></fa-icon>
          </div>
          <h3 class="mt-4 text-lg font-semibold text-[var(--color-gray-800)] dark:text-white">
            {{ state.title }}
          </h3>
          <p class="mt-2 text-sm text-[var(--color-gray-500)] dark:text-[var(--color-gray-300)]">
            {{ state.message }}
          </p>
          <div class="mt-6 space-y-3">
            <button
              type="button"
              class="w-full rounded-full px-4 py-3 text-sm font-semibold text-white shadow-md transition-colors"
              [ngClass]="getConfirmButtonClasses(state.intent)"
              (click)="confirm()"
            >
              {{ state.confirmText }}
            </button>
            <button
              type="button"
              class="w-full rounded-full border border-[var(--color-gray-200)] dark:border-[var(--color-white)]/15 px-4 py-3 text-sm font-semibold text-[var(--color-gray-600)] dark:text-[var(--color-gray-200)] hover:bg-[var(--color-gray-50)] dark:hover:bg-[var(--color-white)]/10 transition-colors"
              (click)="close()"
            >
              {{ state.cancelText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
}
